<template>
  <EditCom
    :title="title"
    :target="target"
    :buttonList="buttonList"
    :inputList="inputList"
    :rules="rules"
    @closeFun="close"
  ></EditCom>
</template>

<script setup>
import { 
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick, reactive,
} from 'vue';
import { isNull, dayjs, message } from '@/utils/js/initVariable';
import EditCom from '@/components/EditCom';

import { putFavorite } from '@/api/UserDrawApi'

// props
const props = defineProps({
  baseTarget: { type: Object },
  target: { type: Object, default: reactive({}) },
  title: { type: String, },
});
// emit
const emit = defineEmits([
  'close', 'submitCallBack',
]);

const close = ()=>{
  emit('close');
}

const submitFn = (item, button, loadFn, fn)=>{
  putFavorite({
    id: item['id'],
    name: item['name'],
    bizId: item['bizId'],
    bizType: 1,
  }).then(res=>{
    if(res.data.code == 1004){
      close();
      emit('submitCallBack');
    }
    loadFn && loadFn();
  }).catch(err=>{
    loadFn && loadFn();
    console.log(err);
  });
}
const submit = (form, item, button, loadFn, fn)=>{
  // console.log(form, item, button, loadFn, fn);
  form.value.validate((valid)=>{
    // console.log(valid);
    if(valid){
      submitFn(item, button, loadFn, fn);
    }else{
      loadFn && loadFn();
    }
  });
};

const buttonList = ref([
  { name: '取消', fun: close, type: 'danger', },
  { name: '确定', fun: submit, type: 'primary', },
]);
const inputList = ref([
  { name: '标注分组名称', prop: 'name', type: 'text', },
  // { name: '文件名称', prop: 'exportName', type: 'text', },
]);
const rules = reactive({
  name: [
    { required: true, message: '请输入标注分组名称', trigger: 'blur' },
  ],
  // exportName: [
  //   { required: true, message: '请输入文件名称', trigger: 'blur' },
  // ],
});

const init = ()=>{
  if(props.target['id']){
    inputList.value.push({
      name: '服务', prop: 'bizId', type: 'select',
      select: {
        list: 'bizIdList',
        label: 'name',
        value: 'id',
        filterable: true,
      }
    });

    rules['bizId'] = [
      { required: true, message: '请选择服务', trigger: 'blur' },
    ]
  }
}

// 组件挂载前
onBeforeMount(()=>{

});
// 组件挂载后
onMounted(()=>{
  init();
});
// 组件更新后
onUpdated(()=>{

});
// 组件销毁后
onUnmounted(()=>{

});

</script>

<style lang='less'>

</style>

<style lang='less' scoped>

</style>